import React, { useRef, useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Toast } from 'primereact/toast';
import { useTranslation, Trans } from "react-i18next";
import "../../Styles/pages/settings.scss";
import PaySwitchActions from "../../Redux/transition/payswitch/payswitch.reducer";
import orchardTips from "../../assets/images/payment_keys_-_orchard_pay.png";
import Loading from '../../Components/Loading';
import BusinessActions from "../../Redux/actions/business-actions"
import DocumentActions from '../../Redux/transition/document-upload/document-upload.reducer';
import { useFormik } from "formik";
import { CustomValidationMessage, CustomInfoMessage } from "../../Components/CustomMessage";
import { isCredentialOverlayLocked } from "../../utils/paymentProviderStatus";

const PROVIDER = "APPSNMOBILE";

function PaymentKeysSettingsAppsNmobile({ onSave, credentialsUnlocked = false }) {

    const dispatch = useDispatch();
    const createCredentials = useCallback((businessId, pmtProvider, credentials) => { dispatch(PaySwitchActions.paySwitchCredentialCreateRequest(businessId, pmtProvider, credentials)) }, [dispatch]);
    const getCredentials = useCallback((businessId, provider) => { dispatch(PaySwitchActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);
    const getBusiness = useCallback((businessId) => { dispatch(BusinessActions.businessRequest(businessId)) }, [dispatch])
    const getVerificationRecord = useCallback((businessId) => { dispatch(DocumentActions.businessVerificationStatusRequest(businessId)) }, [dispatch]);

    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const paymentCredentials = useSelector((state) => state.payswitch.credentials);
    const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
    const creating = useSelector((state) => state.payswitch.creating);
    const errorCreating = useSelector((state) => state.payswitch.errorCreating)
    const credentials = useSelector((state) => state.payswitch.createdCredentials);
    const credentialsError = useSelector((state) => state.payswitch.errorCreatingCredentials);
    const business = useSelector((state) => state.businesses.business);
    const hasOwnCredentials = paymentCredentials?.provider === PROVIDER;
    const overlayLocked = isCredentialOverlayLocked(PROVIDER, business, credentialsUnlocked);

    const op = useRef(null);
    const op1 = useRef(null);
    const toast = useRef(null);
    const { t } = useTranslation("common");
    const [create, setCreate] = useState(false)
    const [save, setSave] = useState(false)
    const [clicked, setClicked] = useState(false)
    const [editTokens, setEditTokens] = useState(false)
    const [toastShown, setToastShown] = useState(false)
    const [errorToastShown, setErrorToastShown] = useState(false)

    const handleChange = (newValue) => {
        setSave(newValue);
        // Pass the updated state to the parent component when provided
        onSave?.(newValue);
    };

    useEffect(() => {
        if (create && !creating && credentials) {
            setClicked(false)
            setToastShown(true)
            setCreate(false);
            window.location.reload();
        }
        if (create && !creating && credentialsError) {
            setErrorToastShown(true)
            setCreate(false)
            formik.setFieldValue("apiUser", "")
            formik.setFieldValue("apiKey", "")
            formik.setFieldValue("merchantId", "")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [create, creating, errorCreating, paymentCredentials])

    const [submit, setSubmit] = useState(0);

    useEffect(() => {
        if (submit > 0) {
            formik.handleSubmit()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submit])

    const formik = useFormik({
        initialValues: {
            apiUser: (paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") || (editTokens) ? "********" : "",
            apiKey: (paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") || (editTokens) ? "*********" : "",
            merchantId: (paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") || (editTokens) ? paymentCredentials?.merchantId : "",
        },

        validate: (data) => {
            let errors = {};
            if (!data.merchantId && submit > 0) {
                errors.merchantId = t("business.payment_serviceId_required");
            }
            if (!data.apiUser && submit > 0) {
                errors.apiUser = t("business.appsNmobile_username_required")
            }
            if (!data.apiKey && submit > 0) {
                errors.apiKey = t("business.payment_secret_token_required")
            }
            return errors;
        },

        onSubmit: data => {
            const credentials = {
                ...data,
                provider: "APPSNMOBILE"
            }
            createCredentials(defMembership.business.id, credentials)
            setCreate(true)
        }
    })

    return (

        <>{fetchingPaymentCredentials && !credentialsUnlocked ? <Loading /> :
            <div>
                <OverlayPanel ref={op} className="payment-keys-overlay">
                    <div>
                        <div className='mb-3 mt-2'>
                            <p className='instruction1-header mb-1'>{t("business.payment_orchard_heading")}</p>
                            <div>
                                <p className='instruction1 mb-1'>{t("business.payment_orchard_info1")}</p>
                                <div className="payment_orchard_info">
                                    <Trans i18nKey="business.payment_orchard_info2"
                                        components={{
                                            1: <span className='instruction2 mb-1'></span>,
                                            2: <span className='instruction1-inner'></span>,
                                            3: <span className='instruction2 mb-1'></span>
                                        }} />
                                </div>

                                <div>
                                    <div>
                                        <Trans i18nKey="business.payment_orchard_info3"
                                            components={{
                                                1: <span className='instruction1 mb-1'></span>,
                                                2: <span className='instruction1-inner ml-1'></span>
                                            }} />
                                    </div>
                                    <div className='instruction1 mt-1'><span>{t("business.payments_copy_txt")}</span></div>
                                </div>
                            </div>
                        </div>
                        <img src={orchardTips} alt={t("business.payment_op1")} style={{ width: "100%", maxWidth: "800px" }} />
                    </div>
                </OverlayPanel>

                <OverlayPanel ref={op1} className="payment-keys-overlay">
                    <div>
                        <div className='mb-3 mt-2'>
                            <div className='instruction2-header mb-1'>{t("business.payment_orchard_bottom_heading")}</div>
                            <div>
                                <p className='instruction1 mb-1'>{t("business.payment_orchard_info1")}</p>

                                <div className="payment_orchard_info">
                                    <Trans i18nKey="business.payment_orchard_info2"
                                        components={{
                                            1: <span className='instruction2 mb-1'></span>,
                                            2: <span className='instruction1-inner'></span>,
                                            3: <span className='instruction2 mb-1'></span>
                                        }} />
                                </div>

                                <div>
                                    <Trans i18nKey="business.payment_orchard_info_bottom3"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>
                                        }} />
                                </div>

                                <div className="payment_orchard_4">
                                    <Trans i18nKey="business.payment_orchard_info4"
                                        components={{
                                            1: <span className='instruction1 mb-1'></span>,
                                            2: <span className='instruction1-inner ml-1'></span>,
                                            3: <span className='instruction1 mb-1'></span>
                                        }} />
                                </div>
                            </div>
                        </div>
                        <img src={orchardTips} alt={t("business.payment_op2")} style={{ width: "100%", maxWidth: "800px" }} />
                    </div>
                </OverlayPanel>

                <Toast ref={toast} onRemove={(message) => {
                    if (message.severity === 'success') {
                        getCredentials(defMembership.business.id, "APPSNMOBILE")
                        getVerificationRecord(defMembership.business.id)
                        getBusiness(defMembership.business.id)
                        formik.resetForm()
                        handleChange(!save)
                        setClicked(false)
                        setSubmit(false)
                    }
                }} />

                <div className="form-container">
                    <form onSubmit={formik.handleSubmit} className="wizard-forms-wrapper p-grid p-nogutter settings-edit-form">
                        <div className="card payment_card">
                            <div className="grid">
                                <div className='hidden md:block col-2'>
                                </div>

                                <div className='col-12 md:col-8'>
                                    <div className="info-icon-div">
                                        <i className="pi pi-info-circle info-icon info-icon-i"
                                            onClick={(e) => { op.current.toggle(e) }}></i>
                                        <span className='payment_token'>{t("business.payment_merchant_info")}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="grid inputs-mb">
                                <div className='col-12 md:col-2'>
                                    <label
                                        id="merchantId-label"
                                        htmlFor="merchantId"
                                        className={"label"}>
                                        {t("business.payment_serviceId")}
                                        <span className="isterik">*</span>
                                    </label>
                                </div>

                                <div className='col-12 md:col-8 apiUser-div-width'>
                                    <InputText
                                        id="merchantId"
                                        name="merchantId"
                                        type='text'
                                        value={formik?.values.merchantId}
                                        onChange={formik?.handleChange}
                                        placeholder={t("business.payment_copy_paste_txt")}
                                        disabled={((business?.pmtProvider === PROVIDER && hasOwnCredentials) && !editTokens) || toastShown}
                                    />
                                </div>
                                {formik.errors.merchantId && formik.errors.merchantId &&
                                    <CustomValidationMessage
                                        className='field_height'
                                        severity="error"
                                        text={t("business.payment_serviceId_required")} />
                                }
                            </div>

                            <hr className="hr_mr" />

                            <div className='inner-payment-card'>
                                <div className='payment-credential'>{t("business.payment_credential")}</div>

                                <div className="grid api-div">
                                    <div className='hidden md:block col-2'>
                                    </div>
                                    <div className='col-12 md:col-8'>
                                        <div className='icon-main-div'><i className="pi pi-info-circle info-icon info-icon-i1"
                                            onClick={(e) => { op1.current.toggle(e) }}></i> <span className='payment_token'>{t("business.payment_token_info")}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid inputs-mb api-div">
                                    <div className='col-12 md:col-2'>
                                        <label
                                            id="apiUser-label"
                                            htmlFor="apiUser"
                                            className={"label"}>
                                            {t("business.payment_clientToken")}
                                            <span className="isterik">*</span>
                                        </label>
                                    </div>

                                    <div className='col-12 md:col-8 apiUser-div-width'>
                                        <InputText
                                            id="apiUser"
                                            name="apiUser"
                                            type='text'
                                            autoComplete="off"
                                            value={formik?.values.apiUser.replace(/./g, '•')}
                                            onChange={formik?.handleChange}
                                            placeholder={t("business.payment_copy_paste_txt")}
                                            disabled={((business?.pmtProvider === PROVIDER && hasOwnCredentials) && !editTokens) || toastShown}
                                        />
                                    </div>
                                    {formik.errors.apiUser && formik.errors.apiUser &&
                                        <CustomValidationMessage
                                            className='field_height'
                                            severity="error"
                                            text={t("business.appsNmobile_username_required")} />
                                    }
                                </div>

                                <div className="grid inputs-mb">
                                    <div className='col-12 md:col-2'>
                                        <label
                                            id="apiKey-label"
                                            htmlFor="apiKey"
                                            className={"label"}>
                                            {t("business.payment_secretToken")}
                                            <span className="isterik">*</span>
                                        </label>
                                    </div>

                                    <div className='col-12 md:col-8 apiUser-div-width'>
                                        <InputText
                                            id="apiKey"
                                            name="apiKey"
                                            type='text'
                                            autoComplete="off"
                                            value={formik?.values.apiKey.replace(/./g, '•')}
                                            onChange={formik?.handleChange}
                                            placeholder={t("business.payment_copy_paste_txt")}
                                            disabled={((business?.pmtProvider === PROVIDER && hasOwnCredentials) && !editTokens) || toastShown}
                                        />
                                    </div>

                                    {formik.errors.apiKey && formik.touched.apiKey &&
                                        <CustomValidationMessage
                                            className='field_height'
                                            severity="error"
                                            text={t("business.payment_secret_token_required")} />
                                    }

                                    {(((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") && !editTokens) ||
                                        ((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") && editTokens && toastShown))
                                        && <div className='col-12 md:col-1 inner-edit'>
                                            <Button
                                                id='innerEdit-btn'
                                                label="Edit"
                                                type='button'
                                                text
                                                severity='info'
                                                onClick={() => {
                                                    setToastShown(false)
                                                    setErrorToastShown(false)
                                                    setEditTokens(true)
                                                    formik.setFieldValue("apiUser", "")
                                                    formik.setFieldValue("apiKey", "")
                                                    formik.setFieldValue("merchantId", "")
                                                    formik.handleChange(false)
                                                }}
                                                loading={creating}
                                            />
                                        </div>}
                                </div>
                            </div>
                        </div >

                        <div id="bottom_buttons_div">
                            <div className='cancel'>
                                {(((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") && clicked && !editTokens) ||
                                    ((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") &&
                                        editTokens && !toastShown && !errorToastShown)) && <Button
                                        className="cancel-button p-button"
                                        id='edit_butto'
                                        label="Cancel"
                                        onClick={() => {
                                            setEditTokens(false)
                                            setToastShown(false)
                                            formik.resetForm()
                                            setErrorToastShown(false)
                                            setClicked(false)
                                            formik.setFieldValue("apiUser", "**********")
                                            formik.setFieldValue("apiKey", "**********")
                                            formik.setFieldValue("merchantId", paymentCredentials?.merchantId)
                                        }}
                                        type='button'
                                        loading={creating}
                                    />}
                            </div>

                            {toastShown &&
                                <CustomInfoMessage
                                    severity="success"
                                    summary=""
                                    detail={t("business.payment_success_info")}
                                />
                            }

                            {creating &&
                                <CustomInfoMessage
                                    severity="warn"
                                    summary=""
                                    detail={t("business.payment_progress_info")}
                                />
                            }

                            {(errorToastShown) &&
                                <CustomInfoMessage
                                    severity="error"
                                    summary=""
                                    detail={t("business.payment_error_info")}
                                />
                            }

                            <div>
                                {(((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") && clicked && !editTokens) ||
                                    ((paymentCredentials && paymentCredentials?.provider === "APPSNMOBILE") && editTokens && !toastShown && !errorToastShown)
                                    || !paymentCredentials || (paymentCredentials && paymentCredentials?.provider !== "APPSNMOBILE")) &&
                                    <Button
                                        onClick={() => {
                                            setSubmit(true)
                                        }}
                                        className="save-button p-button-info"
                                        id='edit_button'
                                        label="Save"
                                        type='submit'
                                        loading={creating}
                                    />}
                            </div>
                        </div>
                    </form >
                    <div id={overlayLocked ? "overlay" : undefined}>
                    </div>
                </div>
            </div >
        }
        </>
    )
}

export default PaymentKeysSettingsAppsNmobile;